import $ from 'jquery';

// Show the referral terms
$(document).on('click', '#referral-terms-overlay', event => {
  event.stopPropagation();
  $('.leads-referral-overlay').removeClass('hide');
  $('.referral-terms-container').removeClass('hide');
});

// Close the referral terms and back to referral modal
$(document).on('click', '#referral-modal-terms-close', () => {
  $('.leads-referral-overlay').addClass('hide');
});
